import makeService from './api';

export default makeService('profil_interfaces');
